const eachYear = (YEARS) => (Array.apply(null, { length: YEARS }).map(Number.call, Number)).map(x => (x + 1));
const nonNegative = x => (x > 0 ? x : 0);
const round2 = x => (parseFloat(x).toFixed(2));
const round = x => (parseInt(x, 10));

const getYears = ({ housePrice, futureHousePricePct, percentLoan, years}) => {
  const futureHousePrice = [ housePrice ];
  const amountProtected = [ housePrice ];
  eachYear(years).forEach(y => {
     const prevHousePrice = futureHousePrice[futureHousePrice.length - 1];
     const housePrice = nonNegative(prevHousePrice * (1 + futureHousePricePct * 0.01));
     futureHousePrice.push(housePrice);
     amountProtected.push(housePrice * (1 - percentLoan));
  });
  return {
    futureHousePrice: round(futureHousePrice[futureHousePrice.length - 1]),
    amountProtected: round(amountProtected[amountProtected.length - 1]),
  };
};

const LtvLevel = {
  Standard: {
    55: 25.5, 56: 26.5, 57: 27.5, 58: 28.5, 59: 29.5, 60: 31, 61: 32, 62: 33, 63: 34, 64: 35, 65: 36,
    66: 37, 67: 38, 68: 39, 69: 40, 70: 41.1, 71: 42.2, 72: 43.4, 73: 44.6, 74: 45.8, 75: 47, 76: 48, 77: 49, 78: 50,
    79: 50.5, 80: 51.5, 81: 52.5, 82: 53, 83: 53, 84: 53, 85: 54, 86: 54, 87: 54, 88: 54, 89: 54, 90: 54
  },
  Mild: {
    55: 30.3, 56: 31.4, 57: 32.5, 58: 33.6, 59: 34.7, 60: 35.8, 61: 36.9, 62: 38, 63: 39.1, 64: 40.2,
    65: 41.3, 66: 42.4, 67: 43.5, 68: 44.6, 69: 45.7, 70: 47.3, 71: 48.4, 72: 49.5, 73: 50.6, 74: 51,
    75: 51.8, 76: 52.9, 77: 54, 78: 54.5, 79: 55.5, 80: 55.5, 81: 55.5, 82: 55.5, 83: 55.5, 84: 55.5,
    85: 55.5, 86: 55.5, 87: 55.5, 88: 55.5, 89: 55.5, 90: 55.5
  }
};

export const guaranteedInheritanceOutput =  (input) => {
  const { years, totalEquityReleased, clientAge, housePrice, futureHousePricePct, qualifyForEnhancedLtv } = input;
  const level = qualifyForEnhancedLtv ? 'Mild' : 'Standard';
  const maxLoan = round(LtvLevel[level][clientAge] * 0.01 * housePrice);
  const percentLoan = round2(totalEquityReleased / maxLoan);
  const offeredNotTaken = round2(1 - parseFloat(percentLoan));
  const amountProtectedAtStart = round((1 - percentLoan) * housePrice);
  const { amountProtected, futureHousePrice } = getYears({ years, housePrice, futureHousePricePct, percentLoan }); // Calculation!c21
  return {
     futureHousePrice,
     level,
     maxLoan,
     percentLoan,
     offeredNotTaken,
     amountProtectedAtStart,
     amountProtected
  };
};



// WEBPACK FOOTER //
// ./src/services/GuaranteedInheritanceCalc.js